module.exports = __webpack_public_path__ + "media/images/redesign-images/home/design-flatlays/design-7-c5b1e462b42e7fb737f8039f759b6c78.png";